import React, { useEffect, useState } from "react";
import { Button, Typography, Modal, message } from "antd";
import { useB2BContext } from "../../context/ContextB2B";
import moment from "moment";
import { authSVC } from "../../services";
import { useNavigate } from "react-router-dom";
import RequestedPackageHDFC from "./RequestedPackageHDFC";
import AddonsModules from "./AddonsModules";
import RequestAddons from "./RequestAddons";
const { Text } = Typography;

function Plan() {
  const { paymentDetails, getUserByID, setPaymentDetails, allPackageList } =
    useB2BContext();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenReference, setIsModalOpenReference] = useState(false);
  const [isModalOpenReferenceAnotherPlan, setIsModalOpenReferenceAnotherPlan] =
    useState(false);
  const [isModalOpenPayment, setIsModalOpenPayment] = useState<any>();
  const [isModalOpenaddons, setIsModalOpenaddons] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");
  const [viewAllModules, setViewAllModules] = useState<any>();
  const [packageData, setPackageData] = useState<any>();
  const [step1, setStep1] = useState<any>(true);
  const [packageName, setPackageName] = useState<any>();
  const [packageId, setPackageId] = useState<any>();
  const [additional, setAdditional] = useState<any>(false);
  const navigate = useNavigate();
  const [copied, setCopied] = useState(false);
  const [referenceId, setReferenceId] = useState<any>();
  const textToCopy = "SSRUPG1234567890";
  const [requestedPackageData, setRequestedPackageData] = useState<any>();
  const [upgradeStatus, setUpgradeStatus] = useState();

  useEffect(() => {
    console.log(requestedPackageData, "requestedPackageData");
    if (requestedPackageData) {
      setIsModalOpenPayment(true);
    }
  }, [requestedPackageData]);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(referenceId);
      setCopied(true);
      message.success("Copied!");
      setTimeout(() => setCopied(false), 2000); // Reset after 2 sec
    } catch (err) {
      console.error("Failed to copy:", err);
    }
  };

  useEffect(() => {
    console.log(selectedOption, "selectedOption");
  }, [selectedOption]);

  const handleOkReference = () => {
    setIsModalOpenReference(true);
  };

  const handleCancelReference = () => {
    setIsModalOpenReference(false);
  };

  const handleOkReferenceAnotherPlan = () => {
    setIsModalOpenReferenceAnotherPlan(true);
  };

  const handleCancelReferenceAnotherPlan = () => {
    setIsModalOpenReferenceAnotherPlan(false);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setStep1(true);
  };
  const handleOkPayment = () => {
    setIsModalOpenPayment(true);
  };

  const handleCancelPayment = () => {
    setIsModalOpenPayment(false);
  };

  const handleOkAddons = () => {
    setIsModalOpenaddons(false);
  };

  const handleCancelAddons = () => {
    setIsModalOpenaddons(false);
  };

  const openPaymentUpdate = () => {
    setIsModalOpen(true);
  };

  const RequestAnotherPlan = () => {
    setIsModalOpen(true);
    setAdditional(true);
    setStep1(false);
  };

  const ClickRequestAnotherPlan = () => {
    authSVC
      .MembershipUpdates({
        user: getUserByID._id,
        package: selectedOption,
        request_type: "additional",
      })
      .then((res: any) => {
        console.log(res.data, "res.data.data.reference_id");
        setReferenceId(res.data.data.reference_id);
        // if (res.data.success) {
        // } else {
        //   message.error(res.data.error);
        // }
        message.success("Request successfully sent.");
        setIsModalOpen(false);
        setIsModalOpenReference(true);
        navigate("/plan");
      })
      .catch((err: any) => {
        console.log(
          err?.response?.data?.availableUpgradeRequest?.reference_id,
          "res.data.data.reference_id"
        );
        setReferenceId(
          err?.response?.data?.availableUpgradeRequest?.reference_id
        );
        setIsModalOpen(false);
        setIsModalOpenReferenceAnotherPlan(true);
        console.log(err.response.data.error);
        message.error(err.response.data.error);
      });
  };

  const ClickUpdate = () => {
    if (selectedOption) {
      authSVC
        .MembershipUpdates({
          user: getUserByID._id,
          package: selectedOption,
        })
        .then((res: any) => {
          console.log(res.data);
          setReferenceId(res.data.data.reference_id);
          // if (res.data.success) {
          // } else {
          //   message.error(res.data.error);
          // }
          message.success("Request successfully sent.");
          setIsModalOpenReference(true);
          setIsModalOpen(false);
          navigate("/plan");
        })
        .catch((err: any) => {
          setReferenceId(
            err?.response?.data?.availableUpgradeRequest?.reference_id
          );
          setIsModalOpen(false);
          setIsModalOpenReferenceAnotherPlan(true);
          console.log(err.response.data.error);
          message.error(err.response.data.error);
        });
    }
  };

  useEffect(() => {
    AllModule();
  }, [getUserByID]);

  const AllModule = async () => {
    authSVC
      .getAllModule()
      .then((res: any) => {
        // setMemberModules(res.data.modules);
        console.log(res.data, "SSSSS");
      })
      .catch((err: any) => {
        message.error(err.message);
      });
  };

  const ViewAddOns = (packageId: any) => {
    console.log(packageId, "packageId");
    setIsModalOpenaddons(true);
    if (getUserByID) {
      authSVC
        .GetModules(getUserByID?.company_id?._id, packageId)
        .then((res: any) => {
          setViewAllModules(res.data);
          console.log(res.data, "setViewAllModules");
        })
        .catch((err: any) => {
          message.error(err.message);
        });
    }
  };

  useEffect(() => {
    if (getUserByID) {
      authSVC
        .getMappedPackageList(getUserByID?.company_id?._id)
        .then((res: any) => {
          console.log(res.data, "getMappedPackageList");
          setPackageData(res.data.package);
        })
        .catch((err: any) => {
          message.error(err.message);
        });

      authSVC
        .UpgradeStatus(getUserByID?.company_id?._id)
        .then((res: any) => {
          console.log(res.data, "UpgradeStatus");
          setUpgradeStatus(res.data.status);
          // setPackageData(res.data.package);
        })
        .catch((err: any) => {
          message.error(err.message);
        });
    }
  }, [getUserByID]);

  useEffect(() => {
    console.log(packageName, "packageName");
  }, [packageName]);

  return (
    <div className="manage_plan_wrapper">
      {getUserByID?.company_id?.package?.map((item: any) => {
        return item.payment_done === false ? (
          <div className="pending_payment_wrapper">
            <p>! Pending Payment(s)</p>
            <button onClick={() => setRequestedPackageData(item)}>
              View & Pay Now
            </button>
          </div>
        ) : (
          <></>
        );
      })}

      <div className="plan_info">
        <Text className="title24">Subscription Plan</Text>
        <div className="content_wrapper subscription">
          {packageData === undefined ? (
            <></>
          ) : packageData ? (
            <>
              {packageData?.map((data: any) => {
                return (
                  <div className="plan_card">
                    <div className="cardHead">
                      <h1>{data?.package}</h1>
                      <div className="border"></div>
                      <p className="next">
                        {data.payment_done ? "Active Plan" : "Not Activated"}{" "}
                      </p>
                      <p className="price">₹{data?.price}</p>
                      <p className="date">
                        Expires On{" "}
                        {moment(data?.next_renewal_date).format("DD MMM YYYY")}
                      </p>
                      <button
                        className="view_addons"
                        onClick={() => {
                          ViewAddOns(data._id);
                          setPackageName(data.package);
                          setPackageId(data._id);
                        }}
                      >
                        View add-ons
                        <img src="/img/view_addons.svg" alt="" />
                      </button>
                    </div>

                    {packageData.length === 2 ? (
                      <></>
                    ) : data?.package === "PLATINUM" ? (
                      <></>
                    ) : upgradeStatus === true ? (
                      <></>
                    ) : (
                      <div className="cardFooter">
                        <Button className="btn" onClick={openPaymentUpdate}>
                          Upgrade Plan
                        </Button>
                      </div>
                    )}
                  </div>
                );
              })}
              {packageData.length === 2 ? (
                <></>
              ) : (
                <Button className="another_plan" onClick={RequestAnotherPlan}>
                  Request another plan
                </Button>
              )}
            </>
          ) : (
            <p
              style={{
                color: "red",
                fontSize: "14px",
                fontWeight: "bold",
                marginTop: "24px",
              }}
            >
              Your subscription plan not activated yet.
            </p>
          )}
        </div>
      </div>
      <Modal
        footer={false}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className="subscribe_popup"
      >
        {step1 ? (
          <>
            <div className="top_box">
              <img src="/Group14181.svg" alt="" />
              <h3>Unlock More Wellness!</h3>
            </div>
            <div className="plan_choos_wrapper bg_none">
              <p className="discription">
                Upgrade your SOULSARA plan today and access premium features
                that take your well-being to the next level.
              </p>
            </div>
            <button
              className="continue_btn"
              onClick={() => {
                setStep1(false);
                setAdditional(false);
              }}
            >
              Upgrade Plan
            </button>
          </>
        ) : (
          <>
            <div className="top_box">
              <img src="/Group14181.svg" alt="" />
              {additional ? (
                <h3>Confirm Request another plan</h3>
              ) : (
                <h3>Confirm Membership Plan</h3>
              )}
            </div>
            <div className="plan_choos_wrapper">
              <div className="line">
                <p>Current Plan</p>
                <h3>{packageData[0]?.package}</h3>
              </div>
              <div className="line">
                {additional ? <p>Request Plan</p> : <p>Upgrade To</p>}

                <select
                  name=""
                  id=""
                  onChange={(e) => setSelectedOption(e.target.value)}
                >
                  <option value="">
                    <span style={{ textTransform: "capitalize" }}>
                      Select Plan
                    </span>
                  </option>
                  {allPackageList &&
                    allPackageList.map((option: any) => {
                      return (
                        packageData[0].package !== option.package && (
                          <option value={option.code}>{option.package}</option>
                        )
                      );
                    })}
                </select>
              </div>
              {/* <button
                onClick={() => {
                  ViewAddOns("6733120080ef7ddff36b8793");
                  setPackageName("PLATINUM");
                }}
              >
                Explore features
              </button> */}
            </div>
            {additional ? (
              <button
                className="continue_btn"
                onClick={ClickRequestAnotherPlan}
                disabled={selectedOption ? false : true}
              >
                Request another plan
              </button>
            ) : (
              <button
                className="continue_btn"
                onClick={ClickUpdate}
                disabled={selectedOption ? false : true}
              >
                Continue
              </button>
            )}
          </>
        )}
      </Modal>
      <Modal
        footer={false}
        open={isModalOpenReference}
        onOk={handleOkReference}
        onCancel={handleCancelReference}
        className="subscribe_popup"
      >
        <div style={{ padding: "60px 0" }}>
          <div className="top_box">
            {/* <img src="/Group17939.png" alt="" /> */}
            <h3>
              Your request has been <br></br>
              successfully processed!
            </h3>
          </div>
          <div className="plan_choos_wrapper bg_none">
            <p className="discription">
              Thank you for submitting your request. We’ll be in touch shortly.
              You can follow up using the reference ID provided, and you’ll also
              receive an email confirmation.
            </p>
          </div>
          <div className="reference">
            <p>
              {" "}
              <strong>Reference ID:</strong>{" "}
              <span
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              ></span>
              {referenceId}
            </p>
            <button onClick={handleCopy}>
              <img src="/Group17935.svg" alt="" />
            </button>
          </div>
          {/* <button className="continue_btn" onClick={() => setStep1(false)}>
            Upgrade Plan
          </button> */}
        </div>
      </Modal>
      <Modal
        footer={false}
        open={isModalOpenReferenceAnotherPlan}
        onOk={handleOkReferenceAnotherPlan}
        onCancel={handleCancelReferenceAnotherPlan}
        className="subscribe_popup"
      >
        <div style={{ padding: "60px 0" }}>
          <div className="top_box">
            <img src="/Group17939.png" alt="" />
            <h3>
              Your request is currently <br></br> being processed!
            </h3>
          </div>
          <div className="plan_choos_wrapper bg_none">
            <p className="discription">
              You can follow up using the reference ID provided.
            </p>
          </div>
          <div className="reference">
            <p>
              {" "}
              <strong>Reference ID:</strong>{" "}
              <span
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              ></span>
              {referenceId}
            </p>
            <button onClick={handleCopy}>
              <img src="/Group17935.svg" alt="" />
            </button>
          </div>
          <a
            href="https://www.soulsara.world/contact-us"
            target="_blank"
            className="continue_btn"
            rel="noreferrer"
          >
            Contact Us
          </a>
        </div>
      </Modal>
      <Modal
        footer={false}
        open={isModalOpenaddons}
        onOk={handleOkAddons}
        onCancel={handleCancelAddons}
        className="subscribe_popup"
      >
        <div className="top_box">
          <img src="img/plan_icon01.svg" alt="" />
          <p className="sub_text">Subscription Plan</p>
          <h2>{packageName}</h2>
        </div>

        <div className="view_addons_item_wrapper">
          <AddonsModules selectedPackageId={packageId} />
          {/* {viewAllModules &&
            viewAllModules?.modules.map((module: any) => {
              return (
                <>
                  <h3>{module.moduleName}</h3>
                  <div className="plan_item_set">
                    <ul>
                      {module.moduleItem.map((data: any) => {
                        return (
                          <li>
                            <img src="/img/Group18838.svg" alt="" />
                            <span>{data.label}</span>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </>
              );
            })} */}
        </div>
      </Modal>

      <Modal
        footer={false}
        open={isModalOpenPayment}
        onOk={handleOkPayment}
        onCancel={handleCancelPayment}
        className="subscribe_popup"
      >
        <RequestedPackageHDFC requestedPackageData={requestedPackageData} />
      </Modal>
    </div>
  );
}

export default Plan;
